/**
 * Extracts userId and adId from pulse cookies.
 * @see {@link https://github.schibsted.io/spt-dataanalytics/event-sdk-js/blob/master/docs/docs/ADID.md|instructions}
 */
function getCookieData() {
  const cookie = decodeURIComponent(
    document.cookie.replace(
      new RegExp(
        `(?:(?:^|.*;)\\s*${encodeURIComponent('_pulse2data').replace(
          /[-.+*]/g,
          '\\$&'
        )}\\s*\\=\\s*([^;]*).*$)|^.*$`
      ),
      '$1'
    )
  );

  return {
    userId: cookie ? cookie.split(',')[2] : undefined,
    adId: cookie ? cookie.split(',')[9] : undefined,
  };
}

export { getCookieData };
